import QRCode from "qrcodejs2";
export default {
  name: "QRCode",
  props: {
    // idName: {
    //   type: String,
    //   default: "qrcodejs2",
    // },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
    text: {
      type: String,
      default: "",
    },
    // 二维码底部文字
    qrText: {
      type: String,
      default: "",
    },
    // 底部说明文字字号
    qrTextSize: {
      type: Number,
      default: 24,
    },
  },
  watch: {
    text(nVal) {
      this.qrcodeUtil.clear();
      this.qrcodeUtil.makeCode(nVal);
    },
  },
  data: () => ({
    idName: "",
    imgUrl: "",
    qrcodeUtil: null,
  }),
  created() {
    this.idName =
      "id_" + Date.now() + "_" + Math.random().toString(36).substring(5, 10);
  },
  mounted() {
    this.$nextTick(() => {
      this.qrcode();
    });
  },
  methods: {
    qrcode() {
      this.qrcodeUtil = new QRCode("qrcode_" + this.idName, {
        width: this.width,
        height: this.height || 100,
        correctLevel: 3,
        text: this.text, // 二维码地址
      });
    },
    base64ToBlob({ b64data = "", contentType = "", sliceSize = 512 } = {}) {
      return new Promise((resolve) => {
        // 使用 atob() 方法将数据解码
        const byteCharacters = window.atob(b64data);
        const byteArrays = [];
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = [];
          for (let i = 0; i < slice.length; i++) {
            byteNumbers.push(slice.charCodeAt(i));
          }
          // 8 位无符号整数值的类型化数组。内容将初始化为 0。
          // 如果无法分配请求数目的字节，则将引发异常。
          byteArrays.push(new Uint8Array(byteNumbers));
        }
        let result = new Blob(byteArrays, {
          type: contentType,
        });
        result = Object.assign(result, {
          // 这里一定要处理一下 URL.createObjectURL
          preview: URL.createObjectURL(result),
          name: `XXX.png`,
        });
        resolve(result);
      });
    },
    async getImgUrl() {
      const Dome = document.querySelector("#qrcode_" + this.idName + ">img");
      if (!Dome) {
        // console.warn("[QRCode] DOM not found:", "qrcode_" + this.idName);
        return;
      }
      this.imgUrl = Dome.getAttribute("src");
      // console.log(this.imgUrl, "-----------------");
      const res = await this.base64ToBlob({
        b64data: this.imgUrl.replace("data:image/png;base64,", ""),
        contentType: "image/png",
      });
      // console.log(res, "-----------this.base64ToBlob");
      window.URL = window.URL || window.webkitURL;
      var url = window.URL.createObjectURL(res);
      return url;
    },
  },
};
